/**
 * ProjectMemberEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PersonEntity } from "../PersonEntity";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
import { ProjectMemberEntity } from "../ProjectMemberEntity";
declare global {
    interface EntityTypeMap {
        ProjectMember: ProjectMemberEntity;
    }
}
export abstract class ProjectMemberGeneratedEntity extends BaseEntity {
    public abstract projectMemberId: string;
    public abstract templateId: string | null;
    public abstract type: string;
    public abstract order: number | null;
    public abstract systemType: boolean;
    public abstract project: ProjectEntity;
    public abstract person: PersonEntity | null;
    public abstract remarkCategory: RemarkCategoryEntity | null;
}
